
import {
  Component, PropSync, Prop, Ref, Mixins, Watch, Inject,
} from 'vue-property-decorator';
import { PackageItem } from '@/features/shipment/types';
import { VForm } from '@/features/common/types';
import focusMixin from '@/features/common/mixins/focusMixin';
import { CreateShipmentValidationState } from '@/features/shipment/helpers/createShipmentValidation';
import AddPackageInputs, { FormData } from './AddPackageInputs.vue';

@Component({
  components: {
    AddPackageInputs,
  },
})
export default class EditPackageItem extends Mixins(focusMixin) {
  @Inject({
    from: 'createShipmentValidationState',
    default: () => ({ attempted: true }),
  })
  private createShipmentValidationState!: CreateShipmentValidationState;

  @Ref('editPackageForm') form!: VForm;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) item!: PackageItem & { index?: number };

  @Prop({ required: true }) packageSummary!: PackageItem[];

  // this flag will determine whether to create shipment or just estimate
  @Prop({ required: false, default: false }) isJustEstimate!: boolean;

  private packageData: FormData = {
    packageType: 'MyPackage',
    weightUnits: 'Lbs',
    weight: '',
    dimUnits: '',
    length: '',
    height: '',
    width: '',
    insurance: '',
    description: '',
    isAdditionalHandling: false,
  };

  private isFormChanged = false;

  @Watch('item', { immediate: true })
  private onItemChanged() {
    this.packageData = {
      packageType: this.item.packageType,
      weightUnits: this.item.weightUnits,
      weight: this.item.weight || '',
      dimUnits: this.item.dimUnits,
      length: this.item.length || '',
      height: this.item.height || '',
      width: this.item.width || '',
      insurance: this.item.insurance || '',
      description: this.item.description,
      isAdditionalHandling: this.item.isAdditionalHandling,
    };
  }

  private async submit(): Promise<void> {
    this.createShipmentValidationState.attempted = true;
    await this.$nextTick();

    const isValid = this.form.validate();
    if (!isValid) return;

    const data: PackageItem = {
      ...this.packageData,
      weight: +this.packageData.weight,
      length: +this.packageData.length,
      height: +this.packageData.height,
      width: +this.packageData.width,
      insurance: +this.packageData.insurance,
      signatureOptions: this.item.signatureOptions,
    };

    const { packageType } = this.packageData;

    if (packageType === 'Pak' || packageType === 'Envelope') {
      data.length = 0;
      data.height = 0;
      data.width = 0;
      data.isAdditionalHandling = false;
    }

    if (packageType === 'Envelope') {
      data.weight = 1;
      data.weightUnits = 'Lbs';
      data.insurance = 0;
    }

    this.$emit('editPackage', data, this.item.index);
    this.syncedShow = false;
  }
}
